<template>
    <a-drawer :title="title" :width="720" :visible="visible" :body-style="{ paddingBottom: '80px', padding: 0 }" @close="onClose">
        <a-form-model ref="form" :model="form" :rules="rules" layout="vertical" class="ant_form">
            <a-row :gutter="16">
                <a-col :span="24">
                    <a-form-model-item label="线路名称" prop="route">
                        <a-input v-model="form.route" placeholder="请输入线路名称" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="24">
                    <a-form-model-item label="始发仓" prop="startWarehouse">
                        <a-select v-model="form.startWarehouse" show-search mode="multiple" style="width: 100%" placeholder="选择始发仓" :options="options" show-arrow />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="24">
                    <a-form-model-item label="目的仓" prop="endWarehouse">
                        <a-select
                            v-model="form.endWarehouse"
                            mode="multiple"
                            style="width: 100%"
                            placeholder="选择目的仓"
                            :options="options"
                            show-arrow
                            @change="handleChange"
                            @deselect="handleDeselect"
                        />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="车型" prop="truckType">
                        <a-select v-model="form.truckType" placeholder="选择车型" allow-clear>
                            <a-select-option v-for="item in CARTYPELIST" :key="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="价格" prop="quotedPrice">
                        <a-input v-model="form.quotedPrice" placeholder="输入价格" suffix="元" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="24">
                    <a-form-model-item label="时效" prop="aging">
                        <div class="aging_style">
                            D
                            <template v-for="(item, index) in agingNum" class="aging_style">
                                +
                                <a-input-number id="inputNumber" :key="item" v-model="aging[index]" :default-value="0" :min="0" @blur="aging[index] = !aging[index] ? 0 : aging[index]" />
                            </template>
                        </div>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="审批状态" prop="approvalStatus">
                        <a-select v-model="form.approvalStatus" placeholder="选择审批状态" :options="approvalOption" allow-clear></a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="满载率" prop="loadF">
                        <a-input v-model="form.loadF" placeholder="输入时效，比如1" suffix="%" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="区域" prop="area">
                        <a-input v-model="form.area" placeholder="输入区域" :max-length="32" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
        <div
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1
            }"
        >
            <a-button style="margin-right: 8px" @click="onClose">取 消</a-button>
            <a-button type="primary" :loading="submitLoading" @click="handleSubmit">保 存</a-button>
        </div>
    </a-drawer>
</template>

<script>
import { formatData } from '@/utils/util';
import { CARTYPELIST, APPROVAL_TYPE, APPROVAL } from '../const';
import { insertQuotation, updateQuotation, stationList } from '../../api';

const costReg = /^(\d|[1-9]\d)(\.\d{1,2})?$|^100(\.0{1,2})?$/;
const priceReg = /^(\d{1,4}|[1-4]{1}\d{0,4})(\.\d{1,2})?$|^50000(\.0{1,2})?$/;
export default {
    name: 'EditQuoteDialog',
    data() {
        const agingValidator = (rule, value, callback) => {
            callback();
        };
        return {
            form: {},
            aging: [0],
            visible: false,
            CARTYPELIST,
            title: '新增报价',
            rules: {
                route: [{ required: true, message: '请填写线路名称', trigger: 'change' }],
                startWarehouse: [{ required: true, message: '请选择始发仓', trigger: 'change' }],
                endWarehouse: [{ required: true, message: '请选择目的仓', trigger: 'change' }],
                truckType: [{ required: true, message: '请选择选择车型', trigger: 'change' }],
                quotedPrice: [
                    { required: true, message: '请输入价格', trigger: 'change' },
                    {
                        pattern: priceReg,
                        message: '请输入[0, 50000]的数字',
                        trigger: 'blur'
                    }
                ],
                aging: [{ required: true, validator: agingValidator, trigger: 'change' }],
                approvalStatus: [{ required: true, message: '请选择审批状态', trigger: 'change' }],
                loadF: [
                    { required: true, message: '请输入满载率', trigger: 'change' },
                    { pattern: costReg, message: '请输入0-100的数字', trigger: 'blur' }
                ]
            },
            options: [],
            submitLoading: false
        };
    },
    computed: {
        approvalOption() {
            return formatData(APPROVAL_TYPE);
        },
        agingNum() {
            return this.form.endWarehouse && this.form.endWarehouse.length ? this.form.endWarehouse.length : 1;
        }
    },
    methods: {
        getNumber(text) {
            const number = (text * 100).toFixed(2);
            const arr = number.split('.');
            if (arr[1] === '00') {
                return arr[0];
            }
            if (arr[1].endsWith(0)) {
                return `${arr[0]}.${arr[1][0]}`;
            }
            return number;
        },
        async show(item) {
            this.title = item ? '编辑报价' : '新增报价';
            if (item) {
                this.form = {
                    ...item,
                    loadF: this.getNumber(item.loadF),
                    approvalStatus: item.approvalStatus === '已审核' ? APPROVAL.APPROVED : APPROVAL.NO_APPROVAL,
                    startWarehouse: item.startWarehouse ? item.startWarehouse.split('+') : '',
                    endWarehouse: item.endWarehouse ? item.endWarehouse.split('+') : ''
                };
                this.form.endWarehouse.forEach((station, index) => {
                    this.aging[index] = item.aging.split('+')[index + 1];
                });
            }
            await this.getStationList();
            this.visible = true;
        },
        async getStationList() {
            const res = await stationList({
                customerCode: this.$store.state.user.tenantId
            });
            this.options = res.map((item) => ({ label: item, value: item }));
        },
        handleChange() {
            this.form.endWarehouse.forEach((item, index) => {
                this.aging[index] = JSON.parse(JSON.stringify(this.aging[index] || 0));
            });
        },
        handleDeselect() {
            this.aging.pop();
        },
        onClose() {
            this.form = {};
            this.aging = [0];
            this.$refs.form.clearValidate();
            this.visible = false;
        },
        async handleSubmit() {
            await this.$refs.form.validate();
            this.submitLoading = true;
            // eslint-disable-next-line camelcase
            const { route, endWarehouse, approvalStatus, startWarehouse, loadF, quotedPrice, truckType, id, area } = this.form;
            const data = {
                quotedPrice,
                truckType,
                customerCode: this.$store.state.user.tenantId,
                route,
                endWarehouse: endWarehouse.join('+'),
                aging: `D+${this.aging.join('+')}`,
                startWarehouse: startWarehouse.join('+'),
                loadF: loadF / 100,
                approvalStatus: APPROVAL_TYPE[approvalStatus],
                area
            };
            try {
                if (this.form.id) {
                    await updateQuotation({ ...data, id });
                    this.$message.success('修改成功');
                } else {
                    await insertQuotation({ ...data });
                    this.$message.success('新增成功');
                }
                this.onClose();
                this.$emit('refresh');
                this.submitLoading = false;
            } catch (error) {
                this.submitLoading = false;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.ant-form {
    padding: 24px;
}
.ant_form {
    margin-bottom: 24px;
}
.aging_style {
    line-height: 40px;
}
</style>
